// @flow

import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { buildText } from "../../_atom/Text";
import Button from "../../_atom/Buttons/button";
import ButtonDefault from "../../_atom/Buttons/default";
import Icon from "../../_static/Icons";

import buildColor from "../../_static/ColorPalette";
import {
  generateTransition,
  easeInOut,
  cubic,
  delayTime,
  grow
} from "../../_static/Transitions";
import { fontMedium } from "../../_static/Typography";

export const BetTicketContainer = styled.div`
  width: 100%;
  ${({ isDualColumn, isVisible }) =>
    isDualColumn &&
    css`
      position: sticky;
      bottom: 0;
      z-index: 10;
      ${!isVisible &&
      css`
        display: none;
      `};
    `};
`;

export const BetTicketSection = styled.section`
  width: 100%;
  z-index: 30;
  bottom: -85px;
  min-height: 85px;
  display: flex;
  max-width: 600px;
  flex: 0 0 auto;
  background-color: ${buildColor("white", "100")};
  box-shadow: 0 -3px 9px 0 ${transparentize(0.85, buildColor("black", "100"))},
    0 1px 3px 0 ${buildColor("black", "100")};
  will-change: bottom, opacity;
  transition: ${generateTransition(cubic, "bottom")},
    ${generateTransition(easeInOut, "opacity")};
  ${(props) =>
    props.isMobile
      ? css`
          position: fixed;
        `
      : css`
          position: sticky;
        `};
  ${(props) =>
    props.isVisible
      ? css`
          bottom: 0;
          opacity: 1;
          transition-delay: ${delayTime};
        `
      : css`
          opacity: 0;
          overflow: hidden;
        `};

  &::before {
    ${(props) =>
      props.isVisible &&
      css`
        content: "";
      `};
    background: transparent;
    height: 20px;
    position: absolute;
    top: -20px;
    width: 100%;
  }
`;

export const TalentPicksWarning = styled.div`
  position: sticky;
  bottom: 85px;
`;

export const BetTypeTrashContainer = styled.div`
  display: flex;
  width: 56px;
  flex: 0 0 auto;
  flex-direction: column;
  background-color: ${buildColor("blue", "000")};
  border-right: 1px solid ${buildColor("blue", "100")};
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
`;

export const WagersSubmitContainer = styled.div`
  flex-grow: 1;
  min-width: 0;
  padding-bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
`;

export const ControlsContainer = styled.div`
  display: flex;
  padding: 8px 8px 8px 0;
`;

export const WagersContainer = styled.div`
  width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: auto;
`;

export const BetTypeText = styled(
  buildText({
    tag: "span",
    align: "center",
    fontSize: 12,
    uppercase: true
  })
)`
  display: flex;
  flex: 0 0 auto;
  width: 40px;
  align-items: center;
  justify-content: center;
  height: 28px;
  background-color: ${buildColor("blue", "000")};
  border-bottom: 1px solid ${buildColor("blue", "100")};
  line-height: 1;
`;

export const SelectionsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  flex-wrap: nowrap;
  overflow: auto;
  height: 28px;
  padding: 0 8px;
  border-bottom: 1px solid ${buildColor("blue", "100")};

  & > ol {
    flex-basis: 0;

    & li > span {
      animation: ${grow} 0.25s;
    }

    &:not(:first-child) {
      margin-left: 8px;
    }
  }
`;

export const SelectionsEmpty = styled(buildText({ tag: "span", fontSize: 12 }))`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 8px;
`;

export const Cancel = styled(ButtonDefault)`
  width: 100%;
  height: 40px;
  flex: 1 0 auto;
  border: 0;
  border-radius: 0;
  background-color: transparent;
`;

export const Add = styled(Icon)`
  border-radius: 50%;
  border: 2px solid ${buildColor("green", "600")};
  margin-left: 4px;
`;

export const BetNowButton = styled(Button)`
  font-weight: normal;
  text-transform: capitalize;

  & > span {
    font-weight: normal;
    line-height: 16px;
    font-size: 14px;
    font-family: ${fontMedium};
    color: ${buildColor("white", "100")};
  }
`;

export const WarningMessageWrapper = styled.div`
  position: absolute;
  bottom: calc(constant(safe-area-inset-bottom) + 96px);
  bottom: calc(env(safe-area-inset-bottom) + 96px);
  left: 0;
  right: 0;
  padding: 8px;
`;
